import React from "react";
import ProductCardSkeleton from "../ProductCardSkeleton/ProductCardSkeleton";

function ProductGridSkeleton({ className = "shop", count = 8 }) {
  return (
    <div
      className={className}
      aria-busy="true"
      aria-label="Loading products"
    >
      {Array.from({ length: count }, (_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

export default ProductGridSkeleton;
